// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-datetime {
  margin: 0 auto;
  background: #f8f9fb;
}

.date-content {
  width: 100%;
  float: none;
  z-index: 9;
}

.time-content {
  width: 100%;
  float: none;
}

.label-date {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

.label-time {
  margin-bottom: 0px;
  margin-left: 16px;
  font-weight: 500;
}

@media (min-width: 960px) {
  .label-date {
    display: none;
  }
  .label-time {
    display: none;
  }
  .date-content {
    width: 40%;
    float: left;
  }
  .time-content {
    width: 40%;
    float: right;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/datetime-picker/datetime-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAGA;EACI;IACI,aAAA;EAAN;EAEE;IACI,aAAA;EAAN;EAGE;IACI,UAAA;IACA,WAAA;EADN;EAIE;IACI,UAAA;IACA,YAAA;EAFN;AACF","sourcesContent":["ion-datetime{\n    margin: 0 auto;\n    background: #f8f9fb;\n}\n\n.date-content{\n    width: 100%;\n    float: none;\n    z-index: 9;\n}\n\n.time-content{\n    width: 100%;\n    float: none;\n}\n\n.label-date{\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n.label-time{\n    margin-bottom: 0px;\n    margin-left: 16px;\n    font-weight: 500;\n}\n\n//PWA\n@media (min-width: 960px) {\n    .label-date{\n        display: none;\n    }\n    .label-time{\n        display: none;\n    }\n\n    .date-content{\n        width: 40%;\n        float: left;\n    }\n    \n    .time-content{\n        width: 40%;\n        float: right;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
